export enum AgentProperty {
  VisitedWelcomeTutorial = 'visited_welcome_tutorial',
}
